// extracted by mini-css-extract-plugin
module.exports = {"notAccessibleContainer":"EmbedPage_notAccessibleContainer__AixGs","watermarkLogo":"EmbedPage_watermarkLogo__Anfc5","watermark":"EmbedPage_watermark__61_8b"};